import { render } from "./sprocess.vue?vue&type=template&id=9e21b6a2&scoped=true"
import script from "./sprocess.vue?vue&type=script&lang=js"
export * from "./sprocess.vue?vue&type=script&lang=js"

import "./sprocess.vue?vue&type=style&index=0&id=9e21b6a2&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e21b6a2"]])

export default __exports__